import React, { useEffect, useState } from 'react';

import { ICircleDataWithSize, IStackedCirclesChart } from '../../../../interfaces/charts';
import BdsTooltip from '../../BdsTooltip/BdsTooltip';

import './StackedCirclesChart.scss';

const MAX_SIZE = 250;
const MIN_SIZE = 120;

const StackedCirclesChart = ({ data, colorScheme, height = 220 }: IStackedCirclesChart) => {
  const [circlesData, setCirclesData] = useState<ICircleDataWithSize[]>([]);
  const [hoveredIndex, setHoveredIndex] = useState<number>(-1);

  const calculateSizes = () => {
    const sorted = [...data].sort((a, b) => b.value - a.value);
    const higherValue = sorted[0].value;
    const lowerValue = sorted[sorted.length - 1].value;
    const mappedData = sorted.map((item) => {
      const size =
        lowerValue >= higherValue * 0.17
          ? Math.floor(MAX_SIZE * Math.sqrt(item.value / higherValue))
          : Math.floor(
              MIN_SIZE + (MAX_SIZE - MIN_SIZE) * Math.sqrt((item.value - lowerValue) / (higherValue - lowerValue))
            );
      return { ...item, size };
    });
    setCirclesData(mappedData);
  };

  const onHover = (index: number) => {
    setHoveredIndex(index);
  };

  useEffect(() => {
    calculateSizes();
  }, [data]);

  return (
    <div className="stacked-circles-container" style={{ height: `${height}px` }}>
      <div className={`legend ${colorScheme}`}>
        {circlesData.map((item, index) => (
          <div
            role="presentation"
            aria-hidden="true"
            className="legend-container"
            key={`legend ${item.label}`}
            onMouseEnter={() => onHover(index)}
            onMouseLeave={() => onHover(-1)}
          >
            <div className={`${colorScheme} color-${index} w-4 h-4 rounded-full`} />
            <div className="units">{item.label}</div>
          </div>
        ))}
      </div>
      {circlesData.map(
        (item, index) =>
          item.value > 0 && (
            <div
              role="presentation"
              aria-hidden="true"
              key={item.label}
              className={`stacked-circle ${colorScheme} color-${index} ${
                hoveredIndex !== -1 && hoveredIndex !== index ? 'fade' : ''
              }`}
              style={{ width: item.size, height: item.size, zIndex: index }}
              onMouseEnter={() => onHover(index)}
              onMouseLeave={() => onHover(-1)}
            >
              <BdsTooltip
                message={item.tooltip}
                position={index === 0 ? 'offset-right' : 'offset-left'}
                open={hoveredIndex === index}
                containerShape="rounded"
                showPointer={false}
              >
                <></>
              </BdsTooltip>
            </div>
          )
      )}
    </div>
  );
};

export default StackedCirclesChart;
